import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * PageSizeNav — page-size selector + prev/next arrows in a single compact pill.
 * Default: 10 records per page. Sizes: 10 / 25 / 50.
 */
export function PageSizeNav({
  pageSize,
  onPageSizeChange,
  page,
  totalPages,
  onPageChange,
  testIdPrefix = 'pagesize',
}) {
  return (
    <div className="inline-flex items-center gap-2" data-testid={`${testIdPrefix}-nav`}>
      <span className="text-[12px] text-slate-500">Show</span>
      <select
        value={pageSize}
        onChange={(e) => onPageSizeChange(Number(e.target.value))}
        data-testid={`${testIdPrefix}-select`}
        className="px-2 py-1.5 rounded-lg bg-white border border-slate-200 text-[12.5px] text-slate-800 focus:outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100"
      >
        <option value={10}>10</option>
        <option value={25}>25</option>
        <option value={50}>50</option>
      </select>
      <span className="text-[12px] text-slate-500 hidden sm:inline">per page</span>
      <div className="ml-1 inline-flex items-center gap-1">
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => onPageChange(Math.max(1, page - 1))}
          data-testid={`${testIdPrefix}-prev`}
          className="p-1.5 rounded-lg border border-slate-200 text-slate-600 bg-white hover:text-indigo-700 hover:bg-indigo-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <ChevronLeft size={14} />
        </button>
        <span className="text-[12px] text-slate-600 min-w-[58px] text-center" data-testid={`${testIdPrefix}-label`}>
          {totalPages > 0 ? `${page} / ${totalPages}` : '0 / 0'}
        </span>
        <button
          type="button"
          disabled={page >= totalPages}
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          data-testid={`${testIdPrefix}-next`}
          className="p-1.5 rounded-lg border border-slate-200 text-slate-600 bg-white hover:text-indigo-700 hover:bg-indigo-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}

export default PageSizeNav;
